import React from 'react';
import classNames from 'classnames';
import WidgetsFactory from '../../../../shared/widgets/components/widgets-factory/widgets-factory-desktop';
import MainLayoutDesktop from 'layouts/main-layout/main-layout.desktop';
import { withHydrate } from '@ecommerce/nest-ssr/common';
import { WidgetsFactoryInterface } from 'modules/shared/widgets/components/widgets-factory/widgets-factory.interfaces';
import BreadcrumbsDesktop from 'modules/shared/components/breadcrumbs/breadcrumbs.desktop';
import Newsletter from 'components/newsletter';
import { articles } from '../../../../../reducers/articles';
import AdSlotTop from 'components/ads/ad-slot-top';
import { ProducerTabProps } from './producer-tab.props';
import { showDSA } from 'modules/shared/widgets/components/widget-dsa/helpers/dsa-helpers';
import WidgetDSATitle from 'modules/shared/widgets/components/widget-dsa/components/widget-dsa-title/widget-dsa-title';
import Container from 'atomic/container/container';
import ProducerTabMenu from '../../components/producer-tab-menu/producer-tab-menu';
import ProducerPageLogo from '../../components/producer-page-logo/producer-page-logo';

import './producer-tab.desktop.scss';

const ProducerTabDesktop: React.FC<ProducerTabProps> = ({ producerTab, producer, breadcrumbs, widgets }) => (
    <MainLayoutDesktop>
        <div className="producer-tab">
            <Container className="screening-bg">
                <div className="row">
                    <div className="col col-12">
                        <AdSlotTop />
                    </div>
                    <div className="col col-12">
                        <BreadcrumbsDesktop breadcrumbs={breadcrumbs} />
                    </div>
                    {producer.config?.dsa && showDSA(producer.config.dsa) && (
                        <div className="col col-12 producer-page__dsa">
                            <WidgetDSATitle dsa={producer.config.dsa} />
                        </div>
                    )}
                    <div className="col col-12">
                        <ProducerPageLogo producer={producer} isMobile={false} />
                    </div>
                </div>
            </Container>
            <ProducerTabMenu producer={producer} producerTab={producerTab} isMobile={false} />
            <Container>
                {Boolean(widgets?.length) && (
                    <div
                        className={classNames('widgets-wrapper', {
                            'producer-sections-desktop': !breadcrumbs?.length
                        })}
                    >
                        <WidgetsFactory
                            config={widgets as WidgetsFactoryInterface[]}
                            dsa={(producer.config?.dsa && showDSA(producer.config.dsa)) ? producer.config?.dsa : void 0}
                        />
                    </div>
                )}
            </Container>
        </div>
        <Newsletter isMobile={false} />
    </MainLayoutDesktop>
);

export default withHydrate(ProducerTabDesktop, {
    root: '#root',
    reducers: { articles }
}, 'modules/producers/views/pages/producer-tabs/producer-tab.desktop');
